import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { logout } from "../../auth/authService";
import { MdMenu, MdClose } from "react-icons/md";
import {
  MdDashboard,
  MdPeople,
  MdAssignmentInd,
  MdManageAccounts,
  MdRecordVoiceOver,
  MdCalendarToday,
  MdLink,
  MdVideoCall,
  MdPersonSearch,
  MdSchool,
  MdGroups,
  MdMenuBook,
  MdCreditCard,
  MdCardGiftcard,
  MdBarChart,
  MdCampaign,
  MdEvent,
  MdNotifications,
  MdEmail,
  MdShare,
  MdStar,
  MdQuestionAnswer,
  MdHeadsetMic,
  MdBuild,
  MdSystemUpdate,
  MdImage,
  MdVideoLibrary,
  MdStorage,
  MdChevronRight,
  MdLogout,
  MdSubscriptions,
  MdAccountBalanceWallet,
  MdHandshake,
  MdPeopleAlt,
  MdTrendingUp,
  MdLeaderboard,
} from "react-icons/md";
import "./AdminLayout.css";

const NAV_GROUPS = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: <MdDashboard />,
    single: true,
    path: "/admin",
    end: true,
  },
  {
    key: "users",
    label: "User Management",
    icon: <MdPeople />,
    items: [
      { label: "Users", path: "/admin/users", icon: <MdPeople /> },
      { label: "Assign Sessions", path: "/admin/assign-sessions", icon: <MdAssignmentInd /> },
      { label: "Account Handling", path: "/admin/admin-account-handling", icon: <MdManageAccounts /> },
    ],
  },
  {
    key: "speakers",
    label: "People Management",
    icon: <MdPeopleAlt />,
    items: [
      { label: "Speakers",             path: "/admin/admin_speakers", icon: <MdRecordVoiceOver /> },
      { label: "Student Coordinators", path: "/admin/coordinators",   icon: <MdPeopleAlt /> },
    ],
  },
  {
    key: "sessions",
    label: "Sessions & Scheduling",
    icon: <MdCalendarToday />,
    items: [
      { label: "Time Table", path: "/admin/admin_time_table", icon: <MdCalendarToday /> },
      { label: "Session Links", path: "/admin/admin-session-links", icon: <MdLink /> },
      { label: "Meeting Rooms", path: "/admin/zoom-meetings", icon: <MdVideoCall /> },
      { label: "Demo Requests", path: "/admin/free-demo", icon: <MdPersonSearch /> },
      { label: "Leads CRM",     path: "/admin/leads",     icon: <MdLeaderboard /> },
    ],
  },
  {
    key: "courses",
    label: "Courses",
    icon: <MdSchool />,
    items: [
      { label: "Courses", path: "/admin/courses", icon: <MdSchool /> },
      { label: "Course Enrollments", path: "/admin/courses/enrollments", icon: <MdGroups /> },
    ],
  },
  {
    key: "calendar",
    label: "Calendar",
    icon: <MdCalendarToday />,
    items: [
      { label: "Global Settings", path: "/admin/calendar/settings", icon: <MdBuild /> },
      { label: "Global Calendar",  path: "/admin/calendar/global",   icon: <MdCalendarToday /> },
    ],
  },
  {
    key: "content",
    label: "Reading Material",
    icon: <MdMenuBook />,
    single: true,
    path: "/admin/content",
  },
  {
    key: "business",
    label: "Business",
    icon: <MdCreditCard />,
    items: [
      { label: "Subscription Plans", path: "/admin/subscription_plans", icon: <MdSubscriptions /> },
      { label: "Free Bundle",        path: "/admin/admin-free-bundle",   icon: <MdCardGiftcard /> },
    ],
  },
  {
    key: "payments",
    label: "Payment Dashboard",
    icon: <MdCreditCard />,
    items: [
      { label: "Income",         path: "/admin/admin-payment-dashboard", icon: <MdTrendingUp /> },
      { label: "Expenses",       path: "/admin/expenses",                icon: <MdAccountBalanceWallet /> },
      { label: "Commissions",    path: "/admin/commissions",             icon: <MdHandshake /> },
      { label: "P&L Analytics",  path: "/admin/analytics/pnl",          icon: <MdBarChart /> },
    ],
  },
  {
    key: "marketing",
    label: "Marketing & Communication",
    icon: <MdCampaign />,
    items: [
      { label: "Events", path: "/admin/admin-events", icon: <MdEvent /> },
      { label: "Announcement", path: "/admin/admin-announcement", icon: <MdNotifications /> },
      { label: "Email Campaign", path: "/admin/email-campaign-page", icon: <MdEmail /> },
      { label: "Social Media", path: "/admin/admin-social-media", icon: <MdShare /> },
      { label: "User Reviews", path: "/admin/admin-user-review", icon: <MdStar /> },
      { label: "FAQ", path: "/admin/admin-faq", icon: <MdQuestionAnswer /> },
    ],
  },
  {
    key: "system",
    label: "System",
    icon: <MdBuild />,
    items: [
      { label: "Support", path: "/admin/admin-support", icon: <MdHeadsetMic /> },
      { label: "Manual Tasks", path: "/admin/admin-manual-task", icon: <MdBuild /> },
      { label: "App Update", path: "/admin/admin-app-update", icon: <MdSystemUpdate /> },
      { label: "Web Images",           path: "/admin/admin-web-images",          icon: <MdImage /> },
      { label: "Media Image Uses",      path: "/admin/admin-media-image-uses",    icon: <MdImage /> },
      { label: "Web Image Categories",  path: "/admin/admin-web-image-categories", icon: <MdImage /> },
      { label: "Media Videos",          path: "/admin/admin-media-videos",         icon: <MdVideoLibrary /> },
      { label: "Media Video Uses",      path: "/admin/admin-media-video-uses",     icon: <MdVideoLibrary /> },
      { label: "DB Backup", path: "/admin/admin-db-backup", icon: <MdStorage /> },
    ],
  },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openGroups, setOpenGroups] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [sidebarOpen]);

  const toggleGroup = (key) => {
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-layout">
      {/* Mobile top bar */}
      <div className="admin-mobile-topbar">
        <button className="admin-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <MdMenu />
        </button>
        <span className="admin-mobile-title">Admin Panel</span>
      </div>

      {/* Overlay */}
      {sidebarOpen && <div className="admin-sidebar-overlay" onClick={() => setSidebarOpen(false)} />}

      <aside className={`admin-sidebar ${sidebarOpen ? "sidebar-open" : ""}`}>
        <div className="admin-logo">
          <span className="admin-logo-text">Admin Panel</span>
          <button className="admin-sidebar-close" onClick={() => setSidebarOpen(false)} aria-label="Close menu">
            <MdClose />
          </button>
        </div>

        <nav className="admin-nav">
          {NAV_GROUPS.map((group) => {
            if (group.single) {
              const isActive = group.end
                ? location.pathname === group.path
                : location.pathname.startsWith(group.path);
              return (
                <NavLink
                  key={group.key}
                  to={group.path}
                  end={group.end}
                  className={`sidebar-single ${isActive ? "active" : ""}`}
                >
                  <span className="sidebar-icon">{group.icon}</span>
                  <span className="sidebar-label">{group.label}</span>
                </NavLink>
              );
            }

            const isGroupActive = group.items.some((item) =>
              location.pathname.startsWith(item.path)
            );
            const isOpen = !!openGroups[group.key];

            return (
              <div key={group.key} className={`sidebar-group ${isGroupActive ? "group-active" : ""}`}>
                <button
                  className={`sidebar-group-header ${isGroupActive ? "active" : ""}`}
                  onClick={() => toggleGroup(group.key)}
                  aria-expanded={isOpen}
                >
                  <span className="sidebar-icon">{group.icon}</span>
                  <span className="sidebar-label">{group.label}</span>
                  <MdChevronRight className={`chevron ${isOpen ? "open" : ""}`} />
                </button>

                <div className={`sidebar-group-items ${isOpen ? "expanded" : ""}`}>
                  {group.items.map((item) => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={({ isActive }) =>
                        `sidebar-item ${isActive ? "active" : ""}`
                      }
                    >
                      <span className="sidebar-item-icon">{item.icon}</span>
                      <span>{item.label}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          })}
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          <MdLogout />
          <span>Logout</span>
        </button>
      </aside>

      <main className="admin-content">
        <div className={["admin-payment-dashboard", "expenses", "coordinators", "commissions", "analytics"].some((p) => location.pathname.includes(p)) ? "" : "admin-page-padding"}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
